import { createSelector } from '@reduxjs/toolkit';
import { AppStateType } from 'src/store/appstate.type';
import { LoaderReducerType } from './LoadingModal.slice';

const selectLoader = (state: AppStateType): LoaderReducerType => state.LoadingReducer;

export const selectLoading = createSelector([selectLoader], (loaderState) => loaderState.loading);
